import axios from 'axios'
import config from './config.js'
import { Message,MessageBox } from 'element-ui'
import store from '../store/index.js'
import * as Sentry from '@sentry/browser'
import qs from 'qs'
import {setSign} from './sign.js'
export default function $axios (options, flag) {
  // options.params = options.params || {}
  // options.timeout = 1000 * 60 * 1
  // console.log('https://es.xiaojukeji.com/Auth/login?redirect_uri=' + customConfig.redirectUri)

  let finalOptions = Object.assign({}, options)
  let finalConfig = Object.assign({}, config)
  return new Promise((resolve, reject) => {
    let groupId = options && options.params && options.params.groupId ? options.params.groupId : store.state.header.selfGroup.groupId
    console.log('groupId',groupId)
    if (!flag && finalOptions.method !== 'post') {
      finalOptions.params = finalOptions.params || {}
      if(groupId){
        Object.assign(finalConfig, { params: { groupId: groupId } })
      }
    } else if (!flag && finalOptions.method === 'post') {
      // finalOptions.params = { ss: 11 }
      let finalData = Object.assign({}, finalOptions.data, { groupId: groupId })
      if (finalOptions.isFormData) {
        finalOptions.data = qs.stringify(finalData)
      } else {
        finalOptions.data = finalData
      }
    }
    const myAxios = axios.create(finalConfig)
    //reequest 拦截器
    myAxios.interceptors.request.use(
      // 请求前需求处理 ps.目前直接返回config
      (finalConfig) =>{
      if (finalConfig.headers['x-requested-with'] == 'del'){
        delete finalConfig.headers['x-requested-with'] 
      }
      let finalConfigWithSign = setSign(finalConfig) 
      // console.log('finalConfig',finalConfig,finalConfig.headers['x-requested-with'])
      return finalConfigWithSign
      },
      // 请求错误处理
      error => {
        Message.error('request_error:', error)
        // 拦截不到，要在 response 拦截器上拦截
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
          Message.error('请求超时，请稍后再试')
        }
        Sentry.captureException(error)
        return Promise.reject(error)
      }
    )

    // response 拦截器
    myAxios.interceptors.response.use(
      response => {
        let data
        let errMessage = getErrMessage(response)
        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        if (response.data === undefined) {
          data = response.request.responseText
        } else {
          data = response.data
        }
        // console.log('response', response.config.url ,response.config.url.indexOf('getAuthSession') < 0 )
        Sentry.configureScope((scope) => {
          // let key = Math.random().toString().slice(-5)
          // scope.setExtra([`url_${key}`], response.request.responseURL)
          // scope.setExtra(response.request.responseURL, data)
          let urlKey = response.request.responseURL.replace(/^(http|https):\/\/eos-marketing\.es\.xiaojukeji\.com/g, '')
          let time = new Date().toLocaleTimeString('zh', { hour12: false })
          scope.setExtra(`[${time}]${urlKey}`, data)
        })
        if (errMessage) {
          Sentry.captureException(errMessage)
          Message.error(errMessage)
        }
        if (typeof data === 'undefined' || data === null) {
          Message.error('出错了')
          return data
        }
        if (data.status === -1) {
          MessageBox.confirm('',data.message,{
            confirmButtonText: '已有账号，去登录',
            cancelButtonText: '没有账号，去了解',
            type: 'warning',
            showClose:false,
            center: true,
            closeOnClickModal:false,
            closeOnPressEscape:false
          }).then(() => {
            window.location.replace('https://passport.didichuxing.com/common/pc-login/3.0.6/index.html?password_encrypt=1&appid=50020&source=70001&role=3&redirectUrl=https%3A%2F%2Fes.xiaojukeji.com%2Fpassport%2FsetCookie%3FreturnUrl%3Dhttps://chuxingquan.xiaojukeji.com?__utm_source=undefined#/')
          }).catch(() => {
            window.location.replace('https://es.xiaojukeji.com/Auth/register?_redirect_uri=' + REDIRECT_URL)
          });
          // window.location.replace('https://es.xiaojukeji.com/Auth/register?_redirect_uri=' + REDIRECT_URL)
          return {}
        }
        // 下载时 response.data.type === 'application/octet-stream'
        if (data.type === 'application/octet-stream') {
          return data
        }
        if (typeof data.status === 'undefined') {
          Message.error('出错了')
          return data
        }
        if (data.status !== 0) {
          Message.error(data.message)
        }
        return data
      },
      err => {
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误'
              break

            case 401:
              err.message = '未授权，请登录'
              break

            case 403:
              err.message = '拒绝访问'
              break

            case 404:
              err.message = `请求地址出错: ${err.response.finalConfig.url}`
              break

            case 408:
              err.message = '请求超时'
              break

            case 500:
              err.message = '服务器内部错误'
              break

            case 501:
              err.message = '服务未实现'
              break

            case 502:
              err.message = '网关错误'
              break

            case 503:
              err.message = '服务不可用'
              break

            case 504:
              err.message = '网关超时'
              break

            case 505:
              err.message = 'HTTP版本不受支持'
              break

            default:
          }
        }
        if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
          Message.error('请求超时，请稍后再试')
        } else {
          Message.error(err.message)
        }
        Sentry.captureException(err)
        return Promise.reject(err)
      }
    )
    // 请求处理
    myAxios(finalOptions)
      .then((res) => {
        resolve(res)
        return false
      })
      .catch((error) => {
        reject(error)
      })
  })
}

function getErrMessage (err) {
  let message
  switch (err.status) {
    case 400:
      message = '请求错误'
      break

    case 401:
      message = '未授权，请登录'
      break

    case 403:
      message = '拒绝访问'
      break

    case 404:
      message = `请求地址出错: ${err.finalConfig.url}`
      break

    case 408:
      message = '请求超时'
      break

    case 500:
      message = '服务器内部错误'
      break

    case 501:
      message = '服务未实现'
      break

    case 502:
      message = '网关错误'
      break

    case 503:
      message = '服务不可用'
      break

    case 504:
      message = '网关超时'
      break

    case 505:
      message = 'HTTP版本不受支持'
      break

    default:
      message = ''
  }
  return message
}
